import Swiper from 'swiper';

const testimonialSlider = document.querySelector('.testimonial-slider');
if (testimonialSlider) {
  const swiper = new Swiper(testimonialSlider, {
    spaceBetween: 24,
    navigation: {
      nextEl: '.testimonial-slider-next',
      prevEl: '.testimonial-slider-prev',
    },
  });

  // // Manually link all navigation buttons (both sets)
  // const nextBtns = document.querySelectorAll('.testimonial-slider-next');
  // const prevBtns = document.querySelectorAll('.testimonial-slider-prev');

  // nextBtns.forEach((btn) =>
  //   btn.addEventListener('click', () => swiper.slideNext())
  // );
  // prevBtns.forEach((btn) =>
  //   btn.addEventListener('click', () => swiper.slidePrev())
  // );
}
